import { DotLegalPaper } from "@dotlegal/dotlegal-ui-components";
import ContractTable from "../../contract/components/ContractTable";
import { useTranslation } from "../../localization/useTranslation";
import useLegalEntityContractTabHooks from "./legalEntityContractTab.hooks";
import { Box } from "@mui/material";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";
import AddContractButton from "../../contract/addContractButton/AddContractButton.tsx";

export interface ILegalEntityContractProps {
    legalEntityId: string;
    onContractsChanged: () => void;
}

function LegalEntityContractTab(props: ILegalEntityContractProps) {
    const { translateString } = useTranslation();
    const { contracts, hasData, isLoading, getFilterOptions, onFilterChange, pinnedFilterIds, onPinnedFilterIdsChange, hasActiveFilters } =
        useLegalEntityContractTabHooks(props);
    const { permissions } = useUserContext();

    return (
        <DotLegalPaper>
            <ContractTable
                contracts={contracts ?? []}
                isLoading={isLoading}
                hasData={hasData}
                emptyStateText={translateString(hasActiveFilters ? "noDataMatchingCriteria" : "noContractsAssociatedToLegalEntity")}
                filterBar={{
                    isLoading: isLoading,
                    filterData: getFilterOptions(),
                    fetchFilterData: true,
                    onMenuClose: onFilterChange,
                    onRemove: onFilterChange,
                    pinnedFilterIds: pinnedFilterIds,
                    onPinnedFilterIdsChange: onPinnedFilterIdsChange,
                }}
            />
            {permissions.contractManagementPermissions.permissions.create && (
                <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 1 }}>
                    <AddContractButton legalEntityId={props.legalEntityId} />
                </Box>
            )}
        </DotLegalPaper>
    );
}

export default LegalEntityContractTab;
